import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { X } from "lucide-react";
import "./css/renderedxlsx.css";

const RenderXlsxTable = ({ columns, data, setViewData }) => {
  const formatColumnHeader = (header) => {
    if (typeof header !== "string") return header;

    const ACRONYMS = ["SSN", "DOB", "ID", "CNIC", "VAT"];

    // Take last part if nested (wallet.activatedAt → activatedAt)
    let text = header.split(".").pop();

    // Replace snake_case / kebab-case
    text = text.replace(/[_-]/g, " ");

    // Split camelCase safely
    text = text.replace(/([a-z0-9])([A-Z])/g, "$1 $2");

    // Normalize spaces
    text = text.replace(/\s+/g, " ").trim();

    // Capitalize words first
    let words = text.split(" ").map((word) => {
      const upper = word.toUpperCase();

      // Only treat as acronym if the FULL word matches
      if (ACRONYMS.includes(upper)) {
        return upper;
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

    return words.join(" ");
  };

  return (
    <>
      <div className="fixed-div"></div>

      <div className="flex flex-wrap flex-row justify-content-center">
        <div className="w-full flex justify-content-end align-items-center"></div>

        <div className="main-renderedxlsx">
          <div className="w-full flex align-content-center justify-content-between">
            <div>
              <label className="top-header">Customer Records</label>
              <label className="top-header-title">
                Displays enrolled customer profiles with identification and
                contact information.
              </label>
            </div>
            <X
              onClick={() => {
                setViewData(null);
              }}
              className=" crossicon "
            />
          </div>

          <DataTable value={data} resizableColumns showGridlines scrollable>
            {columns.map((col, index) => (
              <Column
                key={index}
                field={col}
                header={formatColumnHeader(col)}
              />
            ))}
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default RenderXlsxTable;
